import SmoothScroll from 'smooth-scroll'

/**
 * Terren Select component.
 * @author Dayne Coulson-Hoffacker
 */
export default class TerrenSelect {
  /**
   * Constructs a new scroll TerrenSelect instance.
   * @param {Object} options - Options.
   * @param {HTMLElement} options.element - Container.
   */
  constructor (options) {
    this.element = options.element
    this.scrollTarget = document.body.querySelector('.frm_forms')
    this.scrollBtns = this.element.queryAll('.frm_submit button')
    this.scroll = new SmoothScroll()
    this.scrollOptions = {
      speed: 750,
      updateURL: false,
      offset: 32,
      header: '[data-component="global-header"]'
    }

    this.scrollBtns.forEach(element => {
      element.addEventListener('click', () => {
        this.scroll.animateScroll(this.scrollTarget, element, this.scrollOptions)
      })
    })

  }
}



// WEBPACK FOOTER //
// ./components/section/terren-select/index.js